<template>
    <div class="row" style="position: relative;">
        <AppNav :data="{app_key: 'plan',app_name: '计划',page_name: '我的计划'}" class="col-md-12 pr-0"></AppNav>
        <div class="bar" style="margin: 0px;position: absolute;right: 20px;padding: 6px;">
            <router-link v-if="isOwner" :to="{ name: 'todo'}" style="position: absolute;right: -100%;top:2px;"
                         title="查看待办事项">
                <el-button size="mini" style="padding: 7px;" type="primary">待办事项></el-button>
            </router-link>
            <router-link v-if="!isOwner" :to="{ name: 'todo', query: {'uid': uid}}" style="position: absolute;right: -100%;top:2px;"
                         title="查看待办事项">
                <el-button size="mini" style="padding: 7px;" type="primary">待办事项></el-button>
            </router-link>
        </div>
        <div class="bar" style=" margin: 0;background-image: none;background-color: transparent;position: absolute; left: 35px;
    top: 57px;   padding: 0;z-index: 2">
            <div class="el-radio-group" style="float: left;margin-top:5px;">
                <label class="el-radio-button red el-radio-button--large">
                    <el-radio v-model="planlayout" class="el-radio-button__orig-radio" label="month"
                              @click="set_active_plan_layout('month')"></el-radio>
                    <span class="el-radio-button__inner">月计划</span></label>
                <label class="el-radio-button el-radio-button--large">
                    <el-radio v-model="planlayout" class="el-radio-button__orig-radio" label="year"
                              @click="set_active_plan_layout('year')"></el-radio>
                    <span class="el-radio-button__inner">年计划</span></label>
            </div>
        </div>
        <Month v-if="plan_layout == 'month'" :ViewSize=ViewSize class="col-md-12 pr-0"></Month>
        <Year v-if="plan_layout == 'year'" class="col-md-12 pr-0" :ViewSize=ViewSize></Year>
    </div>
</template>

<script>
import AppNav from '@/components/common_components/nav_bar/app_nav_title.vue'
import Month from '@/apps/plan/sub_components/month_view.vue'
import Year from '@/apps/plan/sub_components/year_view.vue'

// import {mapActions} from 'vuex'
import {mapActions, mapState} from 'vuex'

export default {
    name: "plan_main",
    data: function () {
        return {
            isOwner: true,
            uid: 0,
            ViewSize: 4,
            planlayout: 'month'
        }
    },
    components: {
        AppNav,
        Month,
        Year,
    },
    computed: {
        ...mapState({
            login_user_id: state => state.loginState.user_info.id,
            plan_layout: state => state.plan.active_plan_layout,
        })
    },
    watch: {
        planlayout: function (value, oldValue) {
            this.change_active_plan_layout(value)
        }
    },
    methods: {
        ...mapActions({
            change_active_plan_layout: 'plan/change_active_plan_layout',
            change_display_plans_params: 'plan/change_display_plans_params',
        }),
        set_active_plan_layout(layout) {
            this.change_active_plan_layout(layout)
            this.change_display_plans_params({
                'date': '',
                'type': ''
            })
        }
    },
    created() {
            this.ViewSize=Math.floor(document.body.clientWidth/280)-1;
    },
    mounted() {

        let uid = this.$route.query.uid;
        if (uid) {
            if (uid != this.login_user_id) {
                this.isOwner = false;
                this.uid = uid;
            }
        }
        this.planlayout = this.plan_layout
    }
}
</script>

<style scoped>
.bar a {
    display: inline-block;
    text-decoration: none !important;
    margin-right: 5px;
    border-radius: 2px;
    cursor: pointer;
}

.bar a.active {
    background-color: #c14694;
}

.bar button i.list-icon {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkYzNkFCQ0ZBMTBCRTExRTM5NDk4RDFEM0E5RkQ1NEZCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkYzNkFCQ0ZCMTBCRTExRTM5NDk4RDFEM0E5RkQ1NEZCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RjM2QUJDRjgxMEJFMTFFMzk0OThEMUQzQTlGRDU0RkIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RjM2QUJDRjkxMEJFMTFFMzk0OThEMUQzQTlGRDU0RkIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7h1bLqAAAAWUlEQVR42mL8////BwYGBn4GCACxBRlIAIxAA/4jaXoPEkMyjJ+A/g9MDJQBRhYg8RFqMwg8RJIUINYLFDmBUi+ADQAF1n8ofk9yIAy6WPg4GgtDMRYAAgwAdLYwLAoIwPgAAAAASUVORK5CYII=);
    width: 32px;
    height: 32px;
}

.bar button i.grid-icon {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBEQkMyQzE0MTBCRjExRTNBMDlGRTYyOTlBNDdCN0I4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBEQkMyQzE1MTBCRjExRTNBMDlGRTYyOTlBNDdCN0I4Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MERCQzJDMTIxMEJGMTFFM0EwOUZFNjI5OUE0N0I3QjgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MERCQzJDMTMxMEJGMTFFM0EwOUZFNjI5OUE0N0I3QjgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4MjPshAAAAXklEQVR42mL4////h/8I8B6IGaCYKHFGEMnAwCDIAAHvgZgRyiZKnImBQsACxB+hNoDAQyQ5osQZIT4gH1DsBZABH6AB8x/JaQzEig++WPiII7Rxio/GwmCIBYAAAwAwVIzMp1R0aQAAAABJRU5ErkJggg==);
    width: 32px;
    height: 32px;
}

.bar input {
    background: #fff no-repeat 13px 13px;

    border: none;
    width: 100%;
    line-height: 19px;
    padding: 11px 0;

    border-radius: 2px;
    box-shadow: 0 2px 8px #c4c4c4 inset;
    text-align: left;
    font-size: 14px;
    font-family: inherit;
    color: #738289;
    font-weight: bold;
    outline: none;
    text-indent: 40px;
}

button {
    border-radius: 2px;
    border-style: none;
}

.view-btn {
    padding: 0;
    text-align: center;
    cursor: pointer;
    border: 1px solid #e1e1e1;
}

.view-btn {
    padding: 0 14px;
    height: 28px;
    vertical-align: middle;
    border-color: #e1e1e1;
    background-color: #fff;
    color: #727272;
    font-size: 12px;
    outline: none;
}

.calendar-view-btn {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-right: none;
}

.view-btn.current {
    background-color: #4987a1;
    border-color: #71767a;
    color: #fff;
}

.margin-top-r4 {
    margin-top: -4px;
}

.view-btn em {
    display: inline-block;
    margin-left: 7px;
}

em {
    font-style: normal;
}

.el-radio-group {
    display: inline-block;
    font-size: 0;
}

.el-radio-button {
    height: 30px;
    line-height: 5px;
    position: relative;
    display: inline-block;
}

.el-radio-button__orig-radio {
    opacity: 0;
    outline: 0;
    position: absolute;
    z-index: -1;
    left: -999px;
}

.el-radio-button__inner {
    line-height: 1;
    vertical-align: middle;
}

.el-radio-button__inner {
    position: relative;
    display: inline-block;
}

.el-radio-button__inner {
    white-space: nowrap;
    background: #fff;
    border: 1px solid #bfcbd9;
    border-left: 0;
    color: #1f2d3d;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    cursor: pointer;
    transition: all .3s cubic-bezier(.645, .045, .355, 1);
    padding: 11px;
    font-size: 14px;

}

.el-radio-button__inner {
    height: 30px;
    line-height: 5px;
}

.el-radio-button__orig-radio[aria-checked=true] + .el-radio-button__inner {
    color: #fff;
    background-color: #20a0ff;
    border-color: #20a0ff;
    box-shadow: -1px 0 0 0 #20a0ff;
}

.el-radio-button:first-child .el-radio-button__inner {
    border-left: 1px solid #bfcbd9;
    border-radius: 4px 0 0 4px;
    box-shadow: none !important;
}
</style>